import type React from 'react'
import { buildFormulaTextRuns, type FormulaEditSession } from '../spreadsheet/formulaAuthoring'

interface FormulaSyntaxOverlayProps {
  session: FormulaEditSession | null | undefined
  text: string
  style?: React.CSSProperties
}

const DEFAULT_TEXT_COLOR = '#111827'

export default function FormulaSyntaxOverlay({ session, text, style }: FormulaSyntaxOverlayProps) {
  if (!session || session.mode === 'value') return null
  const runs = buildFormulaTextRuns(text, session.referenceSpans, session.activeReferenceId, session.namedReferenceSpans)

  return (
    <div
      aria-hidden="true"
      className="fg-formula-syntax-overlay"
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        color: DEFAULT_TEXT_COLOR,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        ...style,
      }}
    >
      {runs.map((run, index) => (
        <span
          key={`${index}:${run.referenceId ?? 'text'}`}
          data-formula-named-reference-token={run.namedReference}
          data-formula-reference-token={run.referenceId}
          style={{
            color: run.color ?? 'inherit',
            fontWeight: run.referenceId || run.namedReference ? 700 : 'inherit',
            textDecoration: run.active ? 'underline' : 'none',
            textUnderlineOffset: run.active ? 2 : undefined,
          }}
        >
          {run.text}
        </span>
      ))}
    </div>
  )
}
